<div id="logo-wrapper" *ngIf="showLogo$ | async">
  <img id="logo-overlay" src="../../../assets/logo.png">
</div>

<div id="ThreeJS" #threeJS></div>
<div id="main-ui"#mainUi>
  <app-nav-bar></app-nav-bar>
</div>
